import * as R from 'ramda';
import { MEMBER, OWNER } from '../constants/rule';
/**
 * get event record and return price obj
 *
 * @param  record {Any} event record with price and member_price
 * @return  {{price: Number, memberPrice:Number}} event price
 */
export const getEventPrice = R.pipe(
  R.juxt([R.propOr(0, 'price'), R.propOr(0, 'member_price')]),
  R.zipObj(['price', 'memberPrice'])
);

const priceStr = price => `${price ? `HK $ ${price}` : 'Free'}`;

/**
 * @param {{price: Number, memberPrice:Number}} event price obj
 * @return {String} event price String
 */
export const getEventPriceStr = ({ price, memberPrice }) =>
  `${priceStr(price)} | Member Price: ${priceStr(memberPrice)}`;

/**
 * if user is member or owner, return memberPrice.
 * Otherwise, return price
 */
export const priceByRole = record => role => {
  const { price, memberPrice } = getEventPrice(record);
  return R.ifElse(R.includes(R.__, [MEMBER, OWNER]), R.always(memberPrice), R.always(price))(role);
};
